
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/customers/presence",
      function () {
        return require("private-next-pages/customers/presence.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/customers/presence"])
      });
    }
  